import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Typist from 'react-typist';
import 'react-typist/dist/Typist.css';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import ThreeDotsWave from './ThreeDotsWave';

function Home({ isSmallScreen, windowHeight }) {
  const [text, toggleText] = useState(true);
  const imgUrl = window.location.origin + '/img/image.jpg';
  const ref = useRef(null);

  const toggle = (e) => {
    if (ref.current?.contains(e.target)) {
      // console.log('clicked inside');
    } else {
      // console.log('outside clicked');
      if (isSmallScreen) {
        toggleText(!text);
      }
    }
  };

  const tapVariants = {
    animate: {
      y: [0, -20],
      opacity: 1,
      transition: { yoyo: Infinity, ease: 'easeIn' },
    },
  };

  const bgImgVariants = {
    animate: { scale: 1 },
    initial: { scale: 1.1 },
  };

  //Display Loading until image is loaded
  const [imgLoaded, setImgLoaded] = useState(null);
  useEffect(() => {
    setTimeout(() => {
      const handleLoad = () => {
        setImgLoaded(imgUrl);
      };

      const image = new Image();
      image.addEventListener('load', handleLoad);
      image.src = imgUrl;

      return () => {
        image.removeEventListener('load', handleLoad);
      };
    }, 1000);
  }, []);

  console.log('mouse event disabled?: ', text);
  console.log('is screen small?: ', isSmallScreen);

  return (
    <Container
      onClick={toggle}
      height={windowHeight}
      bgImg={imgLoaded && imgLoaded}
    >
      {imgLoaded ? (
        <div key={text} ref={ref} className='z-10'>
          <Typist cursor={{ show: false }} startDelay={700}>
            <Link to='/about'>
              <HomeText
                label='About'
                className={`home-text top-[17rem] md:top-[10rem] ${
                  isSmallScreen && text ? 'disable-link' : ''
                }`}
              >
                {text ? <span>Hello.</span> : <span>About</span>}
              </HomeText>
              {/* CHange someday if Photo editing portfolio Finished */}
            </Link>
            <Typist.Delay ms={300} />
            <Link to='/works/code'>
              <HomeText
                label='Works'
                className={`home-text top-[22rem] md:top-[17rem] text-blue-150 ${
                  isSmallScreen && text ? 'disable-link' : ''
                }`}
              >
                {text ? <span>I am</span> : <span>Works</span>}
              </HomeText>
            </Link>
            <Link to='/contact'>
              <HomeText
                label='Contact'
                className={`home-text top-[27rem] md:top-[24rem] text-blue-150 ${
                  isSmallScreen && text ? 'disable-link' : ''
                }`}
              >
                {text ? <span>John Paolo</span> : <span>Contact</span>}
              </HomeText>
            </Link>
          </Typist>
          {isSmallScreen && (
            <motion.div variants={tapVariants} animate='animate'>
              <span className='font-medium text-base tracking-wide'>
                Tap Anywhere...
              </span>
            </motion.div>
          )}
        </div>
      ) : (
        <div className='self-center'>
          <ThreeDotsWave />
        </div>
      )}

      <div className='absolute min-w-full min-h-full overflow-hidden'>
        {imgLoaded && (
          <ImgBox
            variants={bgImgVariants}
            initial='initial'
            animate='animate'
            transition={{ duration: 0.3 }}
            className=' absolute min-w-full min-h-full object-cover'
            src={imgLoaded}
            alt=''
          />
        )}
      </div>
    </Container>
  );
}

export default Home;

const Container = styled.div`
  /* background-image: url('${(props) => props.bgImg}');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat; */
  display: relative;
  align-items: flex-end;
  justify-content: center;
  display: flex;
  height: ${(props) => props.height}px;
  width: 100vw;
  background-color: black;
  color: white;
`;

const HomeText = styled.div`
  transition: 0.3s all ease-out;
  :hover > span {
    display: none;
  }
  :hover::before {
    content: '${(props) => props.label}';
  }
`;

const ImgBox = styled(motion.img)`
  z-index: 0;
`;
